var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "gallery-modal-overlay",
          on: {
            click: function($event) {
              $event.target == $event.currentTarget && _vm.close()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "gallery-modal",
              on: {
                click: function($event) {
                  $event.target == $event.currentTarget && _vm.close()
                }
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-close gallery-modal__close",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    { staticClass: "svg-icon svg-icon-close icon-32" },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href": "/img/symbol-defs.svg#svg-icon-close"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "swiper-container gallery-modal__main" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "swiper-wrapper gallery-modal__main-slides"
                    },
                    _vm._l(_vm.items, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "swiper-slide gallery-modal__main-slide"
                        },
                        [
                          item.href && !item.youtube
                            ? _c("img", { attrs: { src: item.href } })
                            : _vm._e(),
                          _vm._v(" "),
                          item.youtube
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "embed-responsive embed-responsive-16by9"
                                },
                                [
                                  _c("iframe", {
                                    staticClass: "embed-responsive-item",
                                    attrs: {
                                      id: "ytplayer",
                                      type: "text/html",
                                      src:
                                        "https://www.youtube.com/embed/" +
                                        item.youtube +
                                        "?autoplay=1&rel=0",
                                      frameborder: "0"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.title
                            ? _c(
                                "div",
                                { staticClass: "gallery-modal__main-title" },
                                [_vm._v(_vm._s(item.title))]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.items.length > 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "gallery-modal__main-nav gallery-modal__main-nav_prev"
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "svg-icon svg-icon-arrow-left icon-32"
                            },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href":
                                    "/img/symbol-defs.svg#svg-icon-arrow-left"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.items.length > 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "gallery-modal__main-nav gallery-modal__main-nav_next"
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "svg-icon svg-icon-arrow-right icon-32"
                            },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href":
                                    "/img/symbol-defs.svg#svg-icon-arrow-right"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.enableThumbnails
                ? _c(
                    "div",
                    { staticClass: "swiper-container gallery-modal__thumbs" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "swiper-wrapper gallery-modal__thumbs-slides"
                        },
                        _vm._l(_vm.items, function(item) {
                          return _c(
                            "div",
                            {
                              key: item.thumbnail,
                              staticClass:
                                "swiper-slide gallery-modal__thumbs-slide"
                            },
                            [_c("img", { attrs: { src: item.thumbnail } })]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }